<template>
  <DragDialog
    title="上传列表"
    :width="1200"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="close"
  >
    <div class="common-table-box">
      <el-table height="100%"  :header-row-class-name="customHeader"
      ref="modelTable" class="publish-table" :data="fileUploadList">
        <el-table-column label="序号" type="index" width="75" />
        <el-table-column label="文件名称" width="320">
          <template v-slot="{ row }">
            <span class="text-overflow" :title="row.fileName">
              {{ row.fileName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="文件大小" width="120">
          <template v-slot="{ row }">
            <span>
              {{
                `${formatFileSize(row.length).fileSize}${
                  formatFileSize(row.length).unit
                }`
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="上传进度" width="270">
          <template v-slot="{ row }">
            <div v-if="row.status === -1 || row.status === -2">
              <span class="wating-text">
                <i class="el-icon-time icon"></i>
                等待上传
              </span>
            </div>
            <div v-else-if="row.status === -3">
              <span class="wating-text">
                <i class="el-icon-time icon"></i>
                等待更新
              </span>
            </div>
            <ProgressBar
              v-else
              mark="dialog-"
              :fileInfo="row"
              :uploadControl="uploadControl"
            />
          </template>
        </el-table-column>
        <el-table-column label="上传至">
          <template v-slot="{ row }">
            <span class="text-overflow" :title="row.projName">
              {{ row.projName ? row.projName : "--" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template v-slot="{ row }">
            <div class="common-button-box operation-cell">
              <el-button
                type="text"
                size="small"
                :disabled="row.status === 1"
                @click="deleteFileById(row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="common-empty-box">
            <bj-empty :image="require('@/assets/img/no-data.png')" class="empty-page">
              <template slot="description">
                <div class="empty-text">抱歉，没有找到相关内容</div>
              </template>
            </bj-empty>
          </div>
        </template>
      </el-table>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";
import ProgressBar from "@/components/ProgressBar.vue";

import { Store } from "@/utils/store";
import { formatFileSize } from "@/utils/generalMethods";
import {
  importUploadListService,
  deleteFileService,
} from "@/service/interface";
export default {
  data() {
    return { fileUploadList: [] ,customHeader:''};
  },
  props: {
    visible: Boolean,
    closeDialog: Function,
  },
  components: {
    DragDialog,
    ProgressBar,
  },
  mounted(){
    this.$nextTick(() => {
      setTimeout(() => {
        const currentBody = this.$refs.modelTable?.bodyWrapper
        currentBody &&
          currentBody.addEventListener('scroll', ev => {
            const scrollTop = ev.target.scrollTop
            this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
          })
      }, 500)
    })
  },  
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initFileUploadList();
      }
    },
  },
  methods: {
    initFileUploadList() {
      this.queryFilesUpload().then(() => {
        this.tableLoading = false;
        if (!this.timer) {
          this.timer = setInterval(this.refreshFileList, 1000);
        }
      });
    },
    refreshFileList() {
      this.queryFilesUpload().then(() => {
        let validFiles = this.fileUploadList.filter(
          (el) => el.status !== 5 && el.status !== 7
        );
        if (!validFiles.length) {
          this.destroyInterval();
        }

        let pauseList = this.fileUploadList.filter((el) => el.status === 2);
        if (pauseList.length) {
          this.refreshDom();
        }
      });
    },
    destroyInterval() {
      this.timer && clearInterval(this.timer);
      this.timer = null;
    },
    close() {
      this.destroyInterval();
      this.closeDialog();
    },
    uploadControl(fileInfo) {
      let find = Store.uploaders.find(
        (el) => el.schemeType === fileInfo.schemeType
      );

      let uploader = find.uploader;
      let fileStatus = fileInfo.status;
      if (fileStatus === 1) {
        uploader.fire("pauseFileUpload", { fileInfo });
      }
      if (fileStatus === 2) {
        uploader.setImportType(fileInfo.importType);
        uploader.setCurrFileInfo(fileInfo);

        let pausedFiles = uploader.pausedFiles;
        let findPauseFile = pausedFiles.find(
          (el) => el.fileDataId === fileInfo.fileDataId
        );
        if (findPauseFile) {
          uploader.setStatus("continue");
          uploader.fire("continueFileUpload", { fileInfo });
        } else {
          uploader.setStatus("reContinue");
        }
      }
    },
    deleteFileById(fileInfo) {
      if (fileInfo.status < 0) {
        let find = Store.uploaders.find(
          (el) => el.schemeType === fileInfo.schemeType
        );
        if (find) {
          let uploader = find.uploader;
          let findIndex = uploader.uploadFiles.findIndex((el) =>
            this.isSameFile(el, fileInfo)
          );
          if (findIndex !== -1) {
            uploader.uploadFiles.splice(findIndex, 1);
          }
        }
        return;
      }

      let fileDataId = fileInfo.id;
      deleteFileService(fileDataId).then((response) => {
        if (response.isSuccess) {
          this.$message.success("删除成功");
          this.refreshFileList();
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    queryFilesUpload() {
      return new Promise((resolve) => {
        let params = {
          resultCount: 1000,
          skipCount: 0,
          name: "",
          status: [0, 1, 2, 5, 6, 7, 8],
        };
        importUploadListService(params).then((response) => {
          if (response.isSuccess) {
            let result = response.data;
            let fileUploadList = result.items;
            fileUploadList = fileUploadList.filter(
              (el) => el.scheme === "ImportDoc"
            );
            fileUploadList.forEach((item) => {
              let bussinessInfo = item.fileBusinessInfo
                ? item.fileBusinessInfo
                : {};
              item["schemeType"] = item.scheme;
              item["importType"] = Number(bussinessInfo.importType);
              item["ownerId"] = bussinessInfo.ProjectOwnerId;
              item["projId"] = bussinessInfo.projId;
              item["projName"] = bussinessInfo.projName;
              item["status"] = item.uploadStatus;
              item["length"] = item.size;
              item["fileDataId"] = item.id;
              if (item.blobIndex || item.blobIndex === 0) {
                let currIndex = item["blobIndex"] + 1;
                let rate = Math.floor((currIndex / item.blobCount) * 10000);
                item["rate"] = rate;
              }
            });

            let uploaders = Store.uploaders.filter((el) =>
              el.schemeType.includes("ImportDoc")
            );
            // 前端的上传文件列表
            let customUploadList = [];
            uploaders.forEach((uploader) => {
              let uploadFiles = uploader.uploader.uploadFiles;
              let uploadingFiles = uploader.uploader.uploadingFiles;

              customUploadList = [
                ...uploadingFiles,
                ...uploadFiles,
                ...customUploadList,
              ];
            });

            customUploadList.forEach((item) => {
              let findIndex = fileUploadList.findIndex((el) =>
                this.isSameFile(el, item)
              );
              if (findIndex === -1) {
                fileUploadList.push(item);
              } else {
                let status = fileUploadList[findIndex].status;
                // 如果后端接口返回的状态不是上传中，则按前端状态显示
                if (status !== 1) {
                  fileUploadList[findIndex].status = item.status;
                }
              }
            });

            this.fileUploadList = fileUploadList;
            resolve();
          }
        });
      });
    },
    isSameFile(fileInfo1, fileInfo2) {
      return (
        fileInfo1.fileName === fileInfo2.fileName &&
        fileInfo1.length === fileInfo2.length
      );
    },
    refreshDom() {
      this.fileUploadList.forEach((item) => {
        let find = Store.uploaders.find(
          (el) => el.schemeType === item.schemeType
        );
        let uploader = find.uploader;
        let pausedFiles = uploader.pausedFiles;
        let findPauseFile = pausedFiles.find((el) => el.fileDataId === item.id);
        if (item.status === 2 && !findPauseFile) {
          let continueDom = document.getElementById(
            `dialog-continue-${item.id}`
          );
          if (continueDom) {
            if (
              !continueDom.children[0] ||
              !continueDom.children[0].className.includes("webuploader-pick")
            ) {
              uploader.uploader.addButton({
                id: `#dialog-continue-${item.id}`,
                multiple: false,
              });
            }
          }
        }
      });
    },
    formatFileSize,
  },
};
</script>

<style lang="less" scoped>
.common-table-box {
  height: 500px;

  .wating-text {
    font-size: 15px;
    color: var(--runing-status-color);
    .icon {
      margin-right: 10px;
    }
  }

  .common-progress-box {
    display: flex;

    .el-progress {
      width: 80%;
    }

    .custom-text {
      width: 60px;
      line-height: 12px;
      font-size: 12px;
      text-align: center;

      .text {
        color: var(--success-status-color);
      }
    }

    &:hover {
      .custom-text {
        display: block;
      }
    }
  }
}
</style>